import setting from "@/api/web/setting";
import InternalSettings from "@/api/web/InternalSettings";
import competitions from "@/api/web/competitions";
import FAQ from "@/api/web/FAQ/index";
import event from "@/api/web/event";
import payment from "./payment";
export default {
    setting,
    InternalSettings,
    competitions,
    FAQ,
    event,
    payment
}